module.exports = __webpack_public_path__ + "img/audio-description-slash.61aac6b7.svg";